import { useState } from 'react';
import { TranslationData } from '../../model';
import './Filter.scss';
import Modal, {
	ModalSize,
} from '../../../../../../components/blackrock/advisor-center/modal-dialog/Modal';
import { FilterConfig } from '../../../../../../components/blackrock/advisor-center/filter-dialog/model';
import FilterDialog from '../../../../../../components/blackrock/advisor-center/filter-dialog/FilterDialog';

export type FilterProps = {
	filter?: FilterConfig;
	filterConfig?: FilterConfig;
	translation: TranslationData;
	calcFilterResult?: (d: FilterConfig) => number;
	setFilter?: React.Dispatch<React.SetStateAction<FilterConfig>>;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const Filter: React.FC<FilterProps> = ({
	filter,
	filterConfig,
	translation,
	calcFilterResult,
	setFilter,
}) => {
	const [isVisible, setIsVisible] = useState<boolean>(false);
	const isButtonVisible =
		!!filterConfig?.authors?.length ||
		!!filterConfig?.topics?.length ||
		!!filterConfig?.publications?.length ||
		!!filterConfig?.types?.length;
	const quantity =
		(filter?.topics?.length || 0) +
		(filter?.publications?.length || 0) +
		(filter?.authors?.length || 0) +
		(filter?.types?.length || 0);

	const onClick = () => setIsVisible(!isVisible);

	const onFilterSubmit = (filter: FilterConfig) => {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		setFilter(filter);
		setIsVisible(false);
	};

	const onFilterCancel = () => setIsVisible(false);

	const onFilterChange = (filter: FilterConfig): number =>
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		calcFilterResult(filter);

	const onCloseCallback = () => setIsVisible(false);

	return (
		isButtonVisible && (
			<>
				<button
					className={'filter ' + (quantity ? 'active' : '')}
					onClick={onClick}
				>
					<span className="filter-label">
						{translation?.filter.label}
						<strong className="filter-label-result-number">({quantity})</strong>
					</span>
					<i className="filter-icon fas fa-sliders-h"></i>
				</button>

				{isVisible && (
					<Modal
						ariaLabelDialog={'Filter dialog'}
						modalSize={ModalSize.LARGE}
						fullScreenOnMobile={true}
						closeCallback={onCloseCallback}
					>
						<FilterDialog
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							filterStateInput={filter}
							filterConfigInput={filterConfig}
							translationMap={translation.filter}
							filterChangeCallback={onFilterChange}
							filterSubmitCallback={onFilterSubmit}
							filterCancelCallback={onFilterCancel}
						/>
					</Modal>
				)}
			</>
		)
	);
};

export default Filter;
